import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiPower, FiLink, FiRefreshCw } from 'react-icons/fi';
import './AdminPanel.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from './Navbar';

const GatewaySettings = () => {
    const [gatewayStatus, setGatewayStatus] = useState('off');
    const [gatewayUrl, setGatewayUrl] = useState('');
    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(true);
    const [authChecked, setAuthChecked] = useState(false);
    const navigate = useNavigate();

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    const checkAuth = async () => {
        try {
            const token = getCookie('offerAdminAuth');
            if (!token) {
                navigate('/adminBT/login');
                return false;
            }

            const res = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'checkAuth',
                authToken: token
            });

            if (!res.data.status) {
                navigate('/adminBT/login');
                return false;
            }
            return true;
        } catch (error) {
            navigate('/adminBT/login');
            return false;
        }
    };

    const fetchGatewaySettings = async () => {
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'getGatewaySettings',
                authToken: token
            });

            if (response.data.status) {
                setGatewayStatus(response.data.data.status || 'off');
                setGatewayUrl(response.data.data.url || '');
            } else {
                console.error('Failed to fetch gateway settings:', response.data.message);
            }
        } catch (error) {
            console.error("Error fetching gateway settings:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const verifyAuth = async () => {
            const isAuthenticated = await checkAuth();
            setAuthChecked(isAuthenticated);
            if (isAuthenticated) {
                await fetchGatewaySettings();
            }
        };
        verifyAuth();
    }, []);

    const handleStatusChange = (status) => {
        setGatewayStatus(status);
    };

    const handleUrlChange = (e) => {
        setGatewayUrl(e.target.value);
    };

    const handleUpdate = async () => {
        setIsUpdating(true);
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'updateGatewaySettings',
                authToken: token,
                status: gatewayStatus,
                url: gatewayUrl
            });

            if (response.data.status) {

            } else {
              
            }
        } catch (error) {
            console.error("Error updating gateway settings:", error);
            alert('Error updating gateway settings');
        } finally {
            setIsUpdating(false);
        }
    };

    const replacementParams = [
        { param: '{vpa}', description: 'User VPA/UPI ID' },
        { param: '{amount}', description: 'Transaction amount' },
        { param: '{txnid}', description: 'Unique transaction ID' },
        { param: '{comm}', description: 'Comment/Note For User' },
    ];

    return (
        <div className="admin-container">
            <Navbar />

            {/* Header */}
            <header className="admin-header">
                <h1>Gateway Settings</h1>
            </header>

            {/* Gateway Settings Card */}
            <motion.div
                className="settings-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
            >
                {/* Status Toggle */}

                <div className="toggle-group">
                    <label>Status</label>
                    <div className="toggle-container">
                        <button
                            type="button"
                            className={`toggle-option ${gatewayStatus === 'on' ? 'active' : ''}`}
                            onClick={() => handleStatusChange('on')}
                            
                        >
                            <FiPower className="toggle-icon" />
                            <span>On</span>
                        </button>
                        <button
                            type="button"
                            className={`toggle-option ${gatewayStatus === 'off' ? 'active' : ''}`} 
                            onClick={() => handleStatusChange('off')} 
                        >
                            <FiPower className="toggle-icon" />
                            <span>Off</span>
                        </button>
                    </div>
                </div>


                {/* Gateway URL Input */}
                <div className="form-group">
                    <label>Gateway URL</label>
                    <div className="input-with-icon">
                        <FiLink className="input-icon" />
                        <input
                            type="text"
                            value={gatewayUrl}
                            onChange={handleUrlChange}
                            placeholder="Enter gateway URL"
                        />
                    </div>
                </div>

                {/* Update Button */}
                <motion.button
                    className="update-button"
                    onClick={handleUpdate}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    disabled={isUpdating}
                >
                    {isUpdating ? (
                        <>
                            <FiRefreshCw className="spinning-icon" />
                            Updating...
                        </>
                    ) : (
                        'Update Gateway'
                    )}
                </motion.button>

                {/* Replacement Parameters */}
                <div className="params-section">
                    <h3 className="params-title">URL Replacement Parameters</h3>
                    <p className="params-description">
                        Use these placeholders in your URL. They will be automatically replaced with actual values during transactions.
                    </p>

                    <div className="params-grid">
                        {replacementParams.map((param) => (
                            <div key={param.param} className="param-card">
                                <div className="param-value">{param.param}</div>
                                <div className="param-description">{param.description}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default GatewaySettings;